import { all, call, fork, takeEvery, put } from "redux-saga/effects";

import {
  CHANGE_LAYOUT,
  CHANGE_LAYOUT_WIDTH,
  CHANGE_SIDEBAR_THEME,
  CHANGE_SIDEBAR_THEME_IMAGE,
  CHANGE_SIDEBAR_TYPE,
  CHANGE_TOPBAR_THEME,
  GO_ACTIVE,
  GO_IDLE,
} from "./actionTypes"

import {
  changeSidebarType as changeSidebarTypeAction,
  changeTopbarTheme as changeTopbarThemeAction,
} from "./actions"

import {
  goActive,
  goIdle,
} from "~/helpers/backendHelper"

/**
 * Changes the body attribute
 */
function changeBodyAttribute(attribute: string, value: string): boolean {
  if (document.body) document.body.setAttribute(attribute, value)
  return true
}



/**
 * Toggle the class on body
 * @param cssClass
 */
function manageBodyClass(cssClass: string, action: "add" | "remove" | "toggle" = "toggle"): boolean {
  switch (action) {
    case "add":
      if (document.body) document.body.classList.add(cssClass)
      break
    case "remove":
      if (document.body) document.body.classList.remove(cssClass)
      break
    default:
      if (document.body) document.body.classList.toggle(cssClass)
      break
  }

  return true
}

/**
 * Changes the layout type
 */
function* changeLayout(action: { type: string; payload: string }) {
  try {
    if (action.payload === "horizontal") {
      yield put(changeTopbarThemeAction("dark"))
      document.body.removeAttribute("data-sidebar")
      document.body.removeAttribute("data-sidebar-image")
      document.body.removeAttribute("data-sidebar-size")
    } else {
      yield put(changeTopbarThemeAction("light"))
    }
    yield call(changeBodyAttribute, "data-layout", action.payload)
  } catch (error) { }
}

/**
 * Changes the layout width
 */
function* changeLayoutWidth(action: { type: string; payload: string }) {
  try {
    if (action.payload === "boxed") {
      yield put(changeSidebarTypeAction("icon", false))
      yield call(changeBodyAttribute, "data-layout-size", action.payload)
      yield call(changeBodyAttribute, "data-layout-scrollable", "false")
    } else if (action.payload === "scrollable") {
      yield put(changeSidebarTypeAction("default", false))
      yield call(changeBodyAttribute, "data-layout-scrollable", "true")
    } else {
      yield put(changeSidebarTypeAction("default", false))
      yield call(changeBodyAttribute, "data-layout-size", action.payload)
      yield call(changeBodyAttribute, "data-layout-scrollable", "false")
    }
  } catch (error) { }
}

/**
 * Changes the left sidebar theme
 */
function* changeLeftSidebarTheme(action: { type: string; payload: string }) {
  try {
    yield call(changeBodyAttribute, "data-sidebar", action.payload)
  } catch (error) { }
}

/**
 * Changes the left sidebar theme Image
 */
function* changeLeftSidebarThemeImage(action: { type: string; payload: string }) {
  try {
    yield call(changeBodyAttribute, "data-sidebar-image", action.payload)
  } catch (error) { }
}

/**
 * Changes the topbar theme
 */
function* changeTopbarTheme(action: { type: string; payload: string }) {
  try {
    yield call(changeBodyAttribute, "data-topbar", action.payload)
  } catch (error) { }
}

/**
 * Changes the left sidebar type
 */
function* changeLeftSidebarType(action: { type: string; payload: { sidebarType: string; isMobile: boolean } }) {
  try {
    switch (action.payload.sidebarType) {
      case "compact":
        yield call(changeBodyAttribute, "data-sidebar-size", "small")
        yield call(manageBodyClass, "sidebar-enable", "remove")
        yield call(manageBodyClass, "vertical-collpsed", "remove")
        break
      case "icon":
        yield call(changeBodyAttribute, "data-sidebar-size", "")
        yield call(changeBodyAttribute, "data-keep-enlarged", "true")
        yield call(manageBodyClass, "vertical-collpsed", "add")
        break
      case "condensed":
        yield call(manageBodyClass, "sidebar-enable", "add")
        if (window.screen.width >= 992) {
          yield call(manageBodyClass, "vertical-collpsed", "remove")
          yield call(manageBodyClass, "sidebar-enable", "remove")
          yield call(manageBodyClass, "vertical-collpsed", "add")
          yield call(manageBodyClass, "sidebar-enable", "add")
        } else {
          yield call(manageBodyClass, "sidebar-enable", "add")
          yield call(manageBodyClass, "vertical-collpsed", "add")
        }
        break
      default:
        yield call(changeBodyAttribute, "data-sidebar-size", "")
        yield call(manageBodyClass, "sidebar-enable", "remove")
        if (!action.payload.isMobile)
          yield call(manageBodyClass, "vertical-collpsed", "remove")
        break
    }
  } catch (error) { }
}

function* onGoIdle() {
  try {
    yield call(goIdle);
  } catch (error) { }
}

function* onGoActive() {
  try {
    yield call(goActive);
  } catch (error) { }
}

/**
 * Watchers
 */
export function* watchChangeLayoutType() {
  yield takeEvery(CHANGE_LAYOUT, changeLayout)
}

export function* watchChangeLayoutWidth() {
  yield takeEvery(CHANGE_LAYOUT_WIDTH, changeLayoutWidth)
}

export function* watchChangeLeftSidebarTheme() {
  yield takeEvery(CHANGE_SIDEBAR_THEME, changeLeftSidebarTheme)
}

export function* watchChangeLeftSidebarThemeImage() {
  yield takeEvery(CHANGE_SIDEBAR_THEME_IMAGE, changeLeftSidebarThemeImage)
}

export function* watchChangeLeftSidebarType() {
  yield takeEvery(CHANGE_SIDEBAR_TYPE, changeLeftSidebarType)
}

export function* watchChangeTopbarTheme() {
  yield takeEvery(CHANGE_TOPBAR_THEME, changeTopbarTheme)
}

export function* watchOnlineStatus() {
  yield takeEvery(GO_IDLE, onGoIdle);
  yield takeEvery(GO_ACTIVE, onGoActive);
}

function* LayoutSaga() {
  yield all([
    fork(watchChangeLayoutType),
    fork(watchChangeLayoutWidth),
    fork(watchChangeLeftSidebarTheme),
    fork(watchChangeLeftSidebarThemeImage),
    fork(watchChangeLeftSidebarType),
    fork(watchChangeTopbarTheme),
    fork(watchOnlineStatus),
  ])
}

export default LayoutSaga
